import { ls, ss } from '@/utils/storage'

const LOCAL_NAME = 'SECRET_TOKEN'

const LOCAL_REFRESH_TOKEN = 'SECRET_REFRESH_TOKEN'

const TOKEN_DIFY = 'TOKEN_DIFY'
const TOKEN_PASS_PORT = 'TOKEN_PASS_PORT'
const APP_CODE = 'APP_CODE'
const CUSTOM_JWT = 'CUSTOM_JWT'
export function getToken() {
  return ss.get(LOCAL_NAME)
}

export function setToken(token: string | undefined) {
  return ss.set(LOCAL_NAME, token)
}

export function removeToken() {
  return ss.remove(LOCAL_NAME)
}

export function getRefreshToken() {
  return ss.get(LOCAL_REFRESH_TOKEN)
}

export function setRefreshToken(token: string | undefined) {
  return ss.set(LOCAL_REFRESH_TOKEN, token)
}

export function removeRefreshToken() {
  return ss.remove(LOCAL_REFRESH_TOKEN)
}

export function getTokenDify() {
  return ss.get(TOKEN_DIFY)
}

export function setTokenDify(token: string | undefined) {
  return ss.set(TOKEN_DIFY, token)
}

export function removeTokenDify() {
  return ss.remove(TOKEN_DIFY)
}

export function getTokenPassPort() {
  return ss.get(TOKEN_PASS_PORT)
}

export function setTokenPassPort(token: string | undefined) {
  return ss.set(TOKEN_PASS_PORT, token)
}

export function removeTokenPassPort() {
  return ss.remove(TOKEN_PASS_PORT)
}

export function getAppCode() {
  return ss.get(APP_CODE)
}

export function setAppCode(token: string | undefined) {
  return ss.set(APP_CODE, token)
}

export function removeAppCode() {
  return ss.remove(APP_CODE)
}

export function getCustomJWT() {
  return ls.get(CUSTOM_JWT)
}

export function setCustomJWT(token: string | undefined) {
  return ls.set(CUSTOM_JWT, token)
}

export function removeCustomJWT() {
  return ls.remove(CUSTOM_JWT)
}
